export default __webpack_public_path__ + "static/properties/20260217-113143.811/common.properties";